import { render } from "./TheLoader.vue?vue&type=template&id=d1b12772"
import script from "./TheLoader.vue?vue&type=script&lang=js"
export * from "./TheLoader.vue?vue&type=script&lang=js"

import "./TheLoader.vue?vue&type=style&index=0&id=d1b12772&lang=css"
script.render = render

export default script